import { motion } from "framer-motion";
import { Carousel } from "antd";
import { useAnimateOnScroll } from "Hooks/useAnimateOnScroll";
import { fadeIn, staggerContainer } from "Features/LandingPage/Common";
import { StyledButton } from "Components/StyledButton";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Features/Routes/routeConstants";
import { advisors } from "Features/OurTeam/AdvisorsSection";
import "./styles.css";

export const CommunitySection = () => {
  const [testimonialRef, testimonialControls] = useAnimateOnScroll(0.1);
  const navigate = useNavigate();

  return (
    <motion.section
      // @ts-ignore
      ref={testimonialRef}
      initial="hidden"
      // @ts-ignore
      animate={testimonialControls}
      variants={fadeIn}
      className="py-20 w-full"
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-8 w-full max-w-7xl">
        <motion.div variants={fadeIn} className="text-center mb-12">
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">
            Meet Our Community
          </h2>
        </motion.div>
        <motion.div variants={staggerContainer} className="w-full m-2">
          <Carousel
            slidesToShow={3}
            slidesToScroll={1}
            className="w-full community-carousel"
            arrows={true}
            dots={false}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {advisors.map((member, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl p-6 shadow-[0_0_10px_rgba(0,0,0,0.2)] hover:shadow-[0_0_10px_rgba(0,0,0,0.2)] hover:-translate-y-2 hover:cursor-pointer transition-all w-full h-full"
              >
                <div className="text-center h-full">
                  <div className="relative mb-6">
                    <img
                      src={member.image}
                      alt={member.name}
                      width={120}
                      height={120}
                      className="rounded-full mx-auto shadow-[0_0_15px_rgba(0,0,0,0.2)]"
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {member.name}
                  </h3>
                  <p className="text-[#80E280] font-bold text-base mb-2">
                    {member.title}
                  </p>
                  <p className="text-gray-600 text-base leading-relaxed mb-4">
                    {member.expertise}
                  </p>
                </div>
              </div>
            ))}
          </Carousel>
        </motion.div>
        <motion.div
          variants={fadeIn}
          className="text-center mt-12 w-full flex justify-center"
        >
          <StyledButton
            onClick={() => {
              navigate(ROUTES.OG_CONNECT);
            }}
            className="w-full md:w-1/2 lg:w-1/3"
          >
            Connect with your Mentor
          </StyledButton>
        </motion.div>
      </div>
    </motion.section>
  );
};
